import { composeTransformers, simplifiers } from '@/utils/transformers';

export const commercialOfferTransformFrom = composeTransformers(
  simplifiers.multiselectSimple('uploadedImages'),
  simplifiers.same('title'),
  simplifiers.selectUuid('offer'),
  simplifiers.selectUuid('category'),
  simplifiers.selectUuid('brand'),
  simplifiers.selectUuid('brandModel'),
  simplifiers.onlyDate('firstRegistration'),
  simplifiers.selectUuid('locationCountry'),
  simplifiers.same('location'),
  simplifiers.selectUuid('targetCountry'),
  simplifiers.same('target'),
  simplifiers.select('financingType'),
  simplifiers.select('scheduleType'),
  simplifiers.same('priceAmount'),
  simplifiers.same('period'),
  simplifiers.same('downPayment'),
  simplifiers.same('agencyFee'),
  simplifiers.simple('contactName'),
  simplifiers.simple('contactEmail'),
  simplifiers.simple('contactPhone'),
  simplifiers.simple('contact'),
  simplifiers.same('sourceType'),
  simplifiers.selectValue('language'),
  simplifiers.same('withVat')
)
